export enum EInvoiceType {
  Invoice = 1,
  CreditNote = 2, // Avoir
  PrepaymentInvoice = 3, // Acompte
  Quote = 4, // Devis
  PurchaseOrder = 5,
  DeliveryOrder = 6  // Bon de livraison
}
